export enum ProcessActionName {
  REGISTRATION_LEAD_SCREEN = 'Registration_DisplayRegistrationPage',
  REGISTRATION_COMPLETED = 'Registration_DisplayThankYouPage',
  LOAN_ERROR_ONBOARDING = 'OnboardingProcess_SendErrorFE',
  EMAIL_VERIFICATION = 'Registration_DisplayEmailVerificationPage',
  LOAN_EXISTING_CUSTOMER = 'Onboarding_DisplayCustomerFoundPage',
  CONTINUE_APPLICATION = 'UserContentDefinitionProcess_ContinueApplicationPage'
}
